import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/pricing-excise')({
  staticData: toStaticData(CRT_ROUTES['/crt/pricing-excise']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route, { atLeastOne: true })
  },
})
